<template>
  <div>
    <List
      url="tasks/"
      :title="title"
      titleClass="title"
      :data="searchData"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealList"
      :MultipleSel="true"
      @edit="edit"
      @download="download"
      @deletedata="deletedata"
    >
      <div slot="Filter">
        <div class="item">
          <label>云平台：</label>
          <el-checkbox-group v-model="platform">
            <el-checkbox
              v-for="platform in platforms"
              :label="platform"
              :key="platform"
              :value="platform"
            >
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label>任务类型：</label>
          <el-checkbox-group v-model="tasktype">
            <el-checkbox
              v-for="filetype in filetypes"
              :label="filetype.ID"
              :key="filetype.ID"
              :value="filetype.ID"
              >{{ filetype.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label>任务提交时间：</label>
          <el-date-picker
            v-model="searchData.begin_time"
            type="date"
            style="width:170px;"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <label style="margin:0 5px;">—</label>
          <el-date-picker
            v-model="searchData.end_time"
            type="date"
            style="width:170px;margin-right:50px;"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button @click="search" type="primary" size="small"
            >搜索</el-button
          >
        </div>
      </div>
    </List>
    <UpdateBox
      :initForm="updateForm"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/TaskList/UpdateBox.vue";
import { Filetypes, filetypesList } from "../components/Index/data.js";
import { Flags, flagsList } from "../components/Index/data.js";
export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "create_time", label: "提交时间" },
        { name: "name", label: "任务名称" },
        { name: "mac", label: "MAC地址" },
        { name: "task_typeName", label: "任务类型" },
        { name: "flagName", label: "任务状态", status: "taskStatus" },
        { name: "username", label: "创建人" },
        { name: "file_upload_time", label: "完成时间" }
      ],
      searchData: {
        task_type: "",
        begin_time: "",
        end_time: "",
        cloud: ""
      },
      tasktype: [],
      platform: [],
      platforms: [
        "ucloud",
        "ecloud",
        "scloud",
        "sacloud",
        "t-healthcare",
        "test_kyy",
        "dev_sh",
        "dev_hz",
        "jcloud",
        "ccloud",
        "aucloud",
        "azcloud",
        "rucloud",
        "discreet",
        "discreet2025",
        "ecloud-tis",
        "dev",
        "test",
        "test84",
        "test_hz",
        "test_hager",
        "手动指定云服务IP"
      ],
      updateList: 0,
      filetypes: filetypesList,
      flags: flagsList,
      title: "任务列表",
      updateBlock: false,
      updateForm: {}
    };
  },
  mounted() {},
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].flagName = Flags[data[i].flag];
        data[i].task_typeName = Filetypes[data[i].task_type];
        data[i].create_time = this.changeDate(data[i].create_time);
        // 格式化完成时间，如果不存在则显示为 "-"
        if (data[i].file_upload_time && data[i].file_upload_time !== null && data[i].file_upload_time !== '') {
          data[i].file_upload_time = this.changeDate(data[i].file_upload_time);
        } else {
          data[i].file_upload_time = "-";
        }
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    search() {
      this.searchData.cloud = this.platform.join(",");
      this.searchData.task_type = this.tasktype.join(",");
      this.updateList++;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateForm = Object.assign({}, val);
    },
    download(val) {
      window.location.href = val.file_url;
    },
    deletedata(val) {
      let url = "tasks/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>
<style scoped>
.item {
  display: flex;
  margin: 10px 15px 0px 0px;
  line-height: 30px;
}
</style>
